import React, { useState } from 'react';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

export default function ESP32Finder() {
  const [ip, setIp] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'

  const fetchFiles = async () => {
    if (!ip) {
      return;
    }

    try {
      setLoading(true);
      setStatus('loading');

      // Fetch CSV file
      const csvResponse = await fetch(`http://${ip}/data.csv`);
      await csvResponse.text();

      // Fetch Config file
      const configResponse = await fetch(`http://${ip}/config.txt`);
      await configResponse.text();

      setStatus('success');
      setTimeout(() => setStatus('idle'), 3000);
    } catch (error) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    } finally {
      setLoading(false);
    }
  };

  const getEndAdornment = () => {
    if (loading) {
      return <CircularProgress size={18} />;
    }
    if (status === 'success') {
      return <CheckCircleIcon sx={{ color: 'success.main', fontSize: 18 }} />;
    }
    if (status === 'error') {
      return <ErrorIcon sx={{ color: 'error.main', fontSize: 18 }} />;
    }
    return null;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <OutlinedInput
        size="small"
        id="esp32-ip-search"
        placeholder="Controller IP"
        value={ip}
        onChange={(e) => setIp(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && fetchFiles()}
        sx={{ width: 180 }}
        startAdornment={
          <InputAdornment position="start">
            <Tooltip title="Fetch data from controller">
              <IconButton
                size="small"
                onClick={fetchFiles}
                disabled={loading || !ip}
                sx={{ p: 0.5 }}
              >
                <SearchRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        }
        endAdornment={
          getEndAdornment() && (
            <InputAdornment position="end">
              {getEndAdornment()}
            </InputAdornment>
          )
        }
        inputProps={{ 'aria-label': 'controller ip search' }}
      />
    </Box>
  );
}
